"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const platforms = [{
  number: "01",
  eyebrow: "Sistemas de Bicos",
  headline: "Desafios Enfrentados pelos Cervejeiros",
  description: "A indústria cervejeira enfrenta um conjunto único de desafios de limpeza que, se não forem resolvidos, podem originar ineficiências e comprometer a qualidade do produto. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Resíduos Persistentes: O malte, o lúpulo e a levedura deixam frequentemente resíduos pegajosos nos tanques de fermentação, difíceis de limpar com métodos convencionais. Elevado Consumo de Água e de Produtos Químicos: Sistemas de limpeza ineficientes podem conduzir a um consumo excessivo de água e de químicos, aumentando os custos operacionais e o impacto ambiental. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Processos Demorados: Ciclos de limpeza longos reduzem a capacidade de produção, atrasam os prazos e aumentam os tempos de paragem. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0Problemas de Humidade nas Embalagens: A humidade residual em garrafas e latas pode prejudicar a rotulagem e a apresentação do produto, causando ineficiências na linha de engarrafamento. Necessidades Frequentes de Manutenção: Sistemas de limpeza desatualizados ou mal mantidos podem resultar em avarias inesperadas e reparações dispendiosas.",
  specs: [{
    label: "EFICIÊNCIA",
    value: "99%"
  }, {
    label: "DURABILIDADE",
    value: "Alta"
  }, {
    label: "NORMAS",
    value: "ISO 9001"
  }],
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.25.png?v=fq9krncqnys",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.25.png?v=idefjisb0se-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.25.png?v=ublt38lkeh-wvc-sizes",
  alt: "Bicos de pulverização industrial de alta precisão em ambiente fabril",
  imageLeft: true
}, {
  number: "02",
  eyebrow: "Engenharia de Sistemas",
  headline: "As Nossas Soluções para Operações da Industria de Cervejas",
  description: "A Spraying Systems Co. orgulha-se de oferecer soluções avançadas de limpeza concebidas especificamente para cervejarias. O nosso equipamento e expertise ajudam-no a superar estes desafios, permitindo: \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Reduzir o consumo de água e de produtos químicos, mantendo uma limpeza completa. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Encurtar os ciclos de limpeza para maximizar o tempo de produção. Eliminar resíduos persistentes, garantindo que os tanques ficam impecáveis em cada lote. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Melhorar a eficiência do engarrafamento com tecnologia avançada de secagem. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Aceder a apoio especializado e manutenção para manter o seu equipamento a funcionar de forma fluida.",
  specs: [{
    label: "PROJETOS",
    value: "Custom"
  }, {
    label: "SUPORTE",
    value: "Total"
  }, {
    label: "INTEGRAÇÃO",
    value: "Fácil"
  }],
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.33.png?v=6tme61cg7xv",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.33.png?v=0qdkvhul357k-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.33.png?v=4no2i11jcdg-wvc-sizes",
  alt: "Sistema de engenharia de pulverização automatizado",
  imageLeft: false
}, {
  number: "03",
  eyebrow: "Parceria Exclusiva",
  headline: "Soluções Avançadas de Limpeza de Tanques para Industria de Cervejas",
  description: "A nossa gama de equipamentos de limpeza de tanques é concebida para responder às rigorosas exigências de limpeza das cervejarias, garantindo uma sanitização completa, ao mesmo tempo que conserva água e reduz os tempos de limpeza. Quer esteja a lidar com tanques de fermentação, tanques de armazenamento ou outros recipientes, as nossas soluções de limpeza de tanques proporcionam um desempenho e uma eficiência inigualáveis. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Designs compactos que se adaptam a aberturas de tanque de pequenas dimensões. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0Poder de limpeza de elevado impacto para resíduos difíceis como malte, lúpulo e levedura. \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0Ciclos de limpeza reduzidos para maximizar o tempo de produção. Opções de configurações de dois ou três bicos para uma limpeza personalizada",
  specs: [{
    label: "PARCERIA",
    value: "1993"
  }, {
    label: "ALCANCE",
    value: "Global"
  }, {
    label: "QUALIDADE",
    value: "Premium"
  }],
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.42.png?v=f1v5ok42y7h",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.42.png?v=5jewveql8q8-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-16.12.42.png?v=knb7yhv1yz-wvc-sizes",
  alt: "Equipamento de pulverização industrial em operação",
  imageLeft: true
}];
export default function ContentShowcase() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".intro-eyebrow", {
        y: 16
      });
      gsap.set(".intro-headline", {
        y: 24
      });
      gsap.to(".intro-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out"
      });
      gsap.to(".intro-headline", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        delay: 0.12
      });
      const rows = gsap.utils.toArray<HTMLElement>(".feature-row");
      rows.forEach(row => {
        const numeral = row.querySelector(".row-numeral");
        const textBits = row.querySelectorAll(".row-text-bit");
        const image = row.querySelector(".row-image");
        gsap.set(numeral, {
          x: -40
        });
        gsap.set(textBits, {
          y: 24
        });
        gsap.set(image, {
          scale: 0.96
        });
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: row,
            start: "top 78%",
            once: true
          }
        });
        tl.to(numeral, {
          opacity: 1,
          x: 0,
          duration: 0.8,
          ease: "power3.out"
        }).to(textBits, {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.12,
          ease: "power3.out"
        }, "-=0.5").to(image, {
          opacity: 1,
          scale: 1,
          duration: 0.9,
          ease: "power3.out"
        }, "-=0.8");
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".intro-eyebrow", ".intro-headline", ".row-numeral", ".row-text-bit", ".row-image"], {
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31335" id="contentshowcase" className="bg-background text-foreground relative overflow-hidden" style={{
    scrollMarginTop: "120px"
  }}>
      <div ref={container} className="mx-auto max-w-[1440px] px-6 sm:px-10 lg:px-16 xl:px-24" style={{
      paddingTop: "clamp(96px, 14vw, 200px)",
      paddingBottom: "clamp(96px, 14vw, 200px)"
    }}>
        {}
        <div className="mx-auto max-w-[720px] text-center mb-24 md:mb-32">
          <div className="intro-eyebrow inline-flex items-center gap-2 mb-6" style={{
          opacity: 0
        }}>
            <span className="inline-block h-1.5 w-1.5 rounded-lg bg-primary" />
            <span className="font-default uppercase text-primary" style={{
            fontSize: "clamp(11px, 0.8vw, 12px)",
            letterSpacing: "0.24em",
            fontWeight: 500,
            lineHeight: 1.4
          }}>
              Eurocontrol
            </span>
          </div>
          <h2 className="intro-headline font-default text-foreground" style={{
          opacity: 0,
          fontSize: "clamp(36px, 5.5vw, 80px)",
          lineHeight: 0.98,
          letterSpacing: "-0.03em",
          fontWeight: 400
        }}>Tecnologia de Pulverização para Fábricas de Cerveja</h2>
        </div>

        {}
        <div className="flex flex-col gap-24 md:gap-32 lg:gap-40">
          {platforms.map((platform, i) => <div key={platform.number} data-index={i} className="feature-row grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 lg:gap-16 items-center">
              {}
              <div className={`md:col-span-6 order-1 ${platform.imageLeft ? "md:order-1" : "md:order-2"}`}>
                <div className="row-image relative overflow-hidden rounded-2xl group bg-muted" style={{
              opacity: 0,
              aspectRatio: "4 / 5"
            }}>
                  {}
                  <div className="pointer-events-none absolute inset-0 bg-accent" aria-hidden="true" />
                  <img src={platform.image} data-wvc-srcset={platform.srcset} data-wvc-sizes={platform.sizes} alt={platform.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />
                  {}
                  <div className="pointer-events-none absolute inset-0 rounded-2xl border border-border" aria-hidden="true" />
                </div>
              </div>

              {}
              <div className={`md:col-span-6 order-2 py-4 md:py-16 ${platform.imageLeft ? "md:order-2" : "md:order-1"}`}>
                {}
                

                {}
                <div className="row-text-bit mb-5" style={{
              opacity: 0
            }}>
                  <span className="font-default uppercase text-muted-foreground" style={{
                fontSize: "clamp(11px, 0.8vw, 12px)",
                letterSpacing: "0.24em",
                fontWeight: 500
              }}>
                    {platform.eyebrow}
                  </span>
                </div>

                {}
                <h3 className="row-text-bit font-default text-foreground" style={{
              opacity: 0,
              fontSize: "clamp(32px, 4vw, 56px)",
              lineHeight: 1.02,
              letterSpacing: "-0.03em",
              fontWeight: 400,
              marginBottom: "clamp(20px, 2vw, 28px)"
            }}>
                  {platform.headline}
                </h3>

                {}
                <p className="row-text-bit font-default text-muted-foreground" style={{
              opacity: 0,
              fontSize: "clamp(17px, 1.25vw, 20px)",
              lineHeight: 1.5,
              fontWeight: 300,
              maxWidth: "520px",
              marginBottom: "clamp(28px, 3vw, 40px)"
            }}>
                  {platform.description}
                </p>

                {}
                <div className="row-text-bit inline-flex flex-wrap items-center gap-4 md:gap-5 mb-8 md:mb-10 px-5 py-3 rounded-lg bg-accent border border-border" style={{
              opacity: 0
            }}>
                  {platform.specs.map((spec, si) => <div key={spec.label} data-index={si} className="flex items-center gap-4 md:gap-5">
                      {si > 0 && <span aria-hidden="true" className="inline-block h-4 w-px bg-border" />}
                      <div className="flex items-baseline gap-2">
                        <span className="font-mono uppercase text-muted-foreground" style={{
                    fontSize: "11px",
                    letterSpacing: "0.08em"
                  }}>
                          {spec.label}
                        </span>
                        <span className="font-mono text-foreground" style={{
                    fontSize: "clamp(12px, 0.85vw, 13px)",
                    lineHeight: 1.5
                  }}>
                          {spec.value}
                        </span>
                      </div>
                    </div>)}
                </div>

                {}
                <div className="row-text-bit" style={{
              opacity: 0
            }}>
                  <Link to="/ProductsPage" className="group inline-flex items-center gap-3 text-foreground">
                    <span className="font-default" style={{
                  fontSize: "clamp(15px, 1.05vw, 16px)",
                  fontWeight: 400,
                  letterSpacing: "0.01em"
                }}>
                      Ver catálogo técnico
                    </span>
                    <span className="inline-flex items-center justify-center h-5 w-5 rounded-lg transition-all duration-300 border border-primary text-primary">
                      <ArrowUpRight className="h-3 w-3" strokeWidth={1.5} />
                    </span>
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}